const HOME_CHAT_HANDOFF_KEY = 'home_chat_handoff_v1'

function getSessionStorage() {
  if (typeof window === 'undefined') {
    return null
  }

  return window.sessionStorage
}

export function setHomeChatHandoff(query: string) {
  const storage = getSessionStorage()
  if (!storage) return

  const trimmedQuery = query.trim()
  if (!trimmedQuery) {
    storage.removeItem(HOME_CHAT_HANDOFF_KEY)
    return
  }

  storage.setItem(HOME_CHAT_HANDOFF_KEY, trimmedQuery)
}

export function consumeHomeChatHandoff() {
  const storage = getSessionStorage()
  if (!storage) return null

  const value = storage.getItem(HOME_CHAT_HANDOFF_KEY)
  storage.removeItem(HOME_CHAT_HANDOFF_KEY)
  return value
}
